import { render, staticRenderFns } from "./bankAccounts.vue?vue&type=template&id=5b1aa3af&scoped=true&"
import script from "./bankAccounts.vue?vue&type=script&lang=js&"
export * from "./bankAccounts.vue?vue&type=script&lang=js&"
import style0 from "./bankAccounts.vue?vue&type=style&index=0&id=5b1aa3af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1aa3af",
  null
  
)

export default component.exports